module.exports = __webpack_public_path__ + "static/media/baku.65ab9769.jpg";